import { render, staticRenderFns } from "./SubmissionAuditTrailHistory.vue?vue&type=template&id=4b952018"
import script from "./SubmissionAuditTrailHistory.vue?vue&type=script&lang=js"
export * from "./SubmissionAuditTrailHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports